import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';

class IptvPaymentMethodsTask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.params = params;
    }

    getMethod() {
        return 'GET';
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + params.user_token
        };
    }

    getParams() {
        const params = super.getParams();
        return {
          device_manufacturer: params.device_manufacturer,
          device_id: params.device_id,
          device_type: params.device_type,
          device_model: params.device_model,
          device_category: params.device_category,
          authpn: params.authpn,
          authpt: params.authpt,
      };
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        return `${http}${url}/services/payway/paymentservice/v1/iptvpaymentmethods`;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default IptvPaymentMethodsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/IptvPaymentMethodsTask.js